module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "navbar-collapse collapse"
  }, [_c('div', {
    staticClass: "user-wrapper"
  }, [_c('div', {
    staticClass: "user-text"
  }, [_vm._v("\n        " + _vm._s(_vm.headerLan.hello) + " ! " + _vm._s(_vm.user.user_name) + "  " + _vm._s(_vm.headerLan.userName) + "\n      ")])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('dropdown', {
    attrs: {
      "tag": "li"
    }
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "role": "button",
      "data-role": "trigger"
    }
  }, [_c('img', {
    staticClass: "position-left language",
    attrs: {
      "src": _vm.languageImage
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.headerLan.language))]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('template', {
    slot: "dropdown"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('cn')
      }
    }
  }, [_c('a', {
    staticClass: "china language"
  }, [_c('img', {
    staticClass: "language",
    attrs: {
      "src": "/static/limitless/assets/images/flags/cn.png"
    }
  }), _vm._v("简体中文")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('hk')
      }
    }
  }, [_c('a', {
    staticClass: "english"
  }, [_c('img', {
    staticClass: "language",
    attrs: {
      "src": "/static/limitless/assets/images/flags/hk.png"
    }
  }), _vm._v("繁體中文")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeLanguage('en')
      }
    }
  }, [_c('a', {
    staticClass: "english"
  }, [_c('img', {
    staticClass: "language",
    attrs: {
      "src": "/static/limitless/assets/images/flags/en.png"
    }
  }), _vm._v("English")])])])], 2)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-header"
  }, [_c('ul', {
    staticClass: "nav navbar-nav visible-xs-block"
  }, [_c('li', [_c('a', {
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#navbar-mobile"
    }
  }, [_c('i', {
    staticClass: "icon-tree5"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "sidebar-mobile-main-toggle"
  }, [_c('i', {
    staticClass: "icon-paragraph-justify3"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4972e2a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 1109
// module chunks = 1